buyBonusPopup = {};

buyBonusPopup.infoText = undefined;

buyBonusPopup.init = function () {
  buyBonusPopup.background = resourceManager.get('buyABonusContainer:buyBonusPopup:buyABonusBackground');

  buyBonusPopup.freeSpinsButton = resourceManager.get(
    'buyABonusContainer:buyBonusPopup:buyABonusBackground:freeSpinsButton'
  );

  buyBonusPopup.freeSpinsButton.onPressedCallback = buyBonusPopup.onClickedFreeSpins;

  buyBonusPopup.closeButton = resourceManager.get('buyABonusContainer:buyBonusPopup:buyABonusBackground:closeButton');

  buyBonusPopup.closeButton.onPressedCallback = buyBonusPopup.onClickedNo;

  buyBonusPopup.stakePreviousButton = resourceManager.get(
    'buyABonusContainer:buyBonusPopup:buyABonusBackground:stakePrevious'
  );

  buyBonusPopup.stakePreviousButton.onPressedCallback = buyBonusPopup.onStakePreviousPressed;

  buyBonusPopup.stakeNextButton = resourceManager.get('buyABonusContainer:buyBonusPopup:buyABonusBackground:stakeNext');

  buyBonusPopup.stakeNextButton.onPressedCallback = buyBonusPopup.onStakeNextPressed;

  buyBonusPopup.baseStakeText = resourceManager.get(
    'buyABonusContainer:buyBonusPopup:buyABonusBackground:baseStakeText'
  );

  buyBonusPopup.freeSpinsCostValue = resourceManager.get(
    'buyABonusContainer:buyBonusPopup:buyABonusBackground:freeSpinsCostValue'
  );
};

buyBonusPopup.show = function (callback) {
  const stakeController = resourceManager.getController('stakeController');
  buyBonusPopup.open = true;

  buyBonusPopup.freeSpinsButton.enableButton(true);

  buyBonusPopup.closeButton.enableButton(true);

  messageBus.post('game:modal', { reason: 'buy_bonus', data: 'buy_bonus_show' });

  buyBonusPopup.freeSpinsStakes = buyBonusPopup.gameConfig.data.slotConfig.gameModes.FREESPINS_BUY.coinSizes;

  const bonusBuyStake =
    buyBonusPopup.freeSpinsStakes[buyBonusPopup.gameConfig.data.slotConfig.gameModes.default._selectedStakeIndex];

  if (bonusBuyStake !== undefined) {
    buyBonusPopup.stakeIndex = buyBonusPopup.gameConfig.data.slotConfig.gameModes.default._selectedStakeIndex;
  } else {
    buyBonusPopup.stakeIndex = buyBonusPopup.freeSpinsStakes.length - 1;
  }

  buyBonusPopup.updatePopup();

  resourceManager.getContainer('buyABonusContainer').visible = true;
  buyBonusPopup.container.visible = true;
  buyBonusPopup.callback = callback;
};

buyBonusPopup.updatePopup = function () {
  if (buyBonusPopup.stakeIndex === -1) {
    // Something went wrong here. No compatible stakes found
    buyBonusPopup.stakePreviousButton.enableButton(false);
    buyBonusPopup.stakeNextButton.enableButton(false);

    buyBonusPopup.freeSpinsButton.enableButton(false);
  } else {
    const bonusBuyStakes = buyBonusPopup.freeSpinsStakes;

    // update the stake buttons
    buyBonusPopup.stakePreviousButton.enableButton(buyBonusPopup.stakeIndex > 0);
    buyBonusPopup.stakeNextButton.enableButton(buyBonusPopup.stakeIndex < bonusBuyStakes.length - 1);

    // update the base stake box
    let baseStake = buyBonusPopup.convertToTotalStake(bonusBuyStakes[buyBonusPopup.stakeIndex]);
    buyBonusPopup.baseStakeText.setText(gdk.formatCurrency(baseStake));

    // check stake is valid
    const freeSpinsStakes = buyBonusPopup.gameConfig.data.slotConfig.gameModes.FREESPINS_BUY.coinSizes;
    const stakeToFind = bonusBuyStakes[buyBonusPopup.stakeIndex];

    let freeSpinsStakeExists = freeSpinsStakes.includes(stakeToFind);

    // Free spins costs
    let costFreeSpins = baseStake * buyBonusPopup.gameConfig.data.buyBonusCostFreeSpins;
    buyBonusPopup.freeSpinsCostValue.setText(gdk.formatCurrency(costFreeSpins));
    buyBonusPopup.freeSpinsButton.enableButton(buyBonusPopup.balance >= costFreeSpins && freeSpinsStakeExists);
  }
};

buyBonusPopup.create = function (json) {
  return new PIXI.Container();
};

buyBonusPopup.convertToTotalStake = function (coinSize) {
  const stakeController = resourceManager.getController('stakeController');
  const numLines = stakeController.CurrentWinLineCount;

  return coinSize * numLines;
};

buyBonusPopup.onStakeNextPressed = function () {
  soundManager.play('buttonPressed');

  const bonusBuyStakes = buyBonusPopup.freeSpinsStakes;
  buyBonusPopup.stakeIndex = Math.min(buyBonusPopup.stakeIndex + 1, bonusBuyStakes.length - 1);
  buyBonusPopup.updatePopup();
};

buyBonusPopup.onStakePreviousPressed = function () {
  soundManager.play('buttonPressed');

  buyBonusPopup.stakeIndex = Math.max(buyBonusPopup.stakeIndex - 1, 0);
  buyBonusPopup.updatePopup();
};

buyBonusPopup.initialise = function (json, container) {
  buyBonusPopup.container = container;
  buyBonusPopup.container.visible = false;

  buyBonusPopup.fadedMask = new PIXI.Graphics();
  buyBonusPopup.fadedMask.beginFill(0, 0.8);
  buyBonusPopup.fadedMask.drawRect(-10000, -10000, 20000, 20000);
  buyBonusPopup.fadedMask.endFill();
  buyBonusPopup.container.addChild(buyBonusPopup.fadedMask);
  messageBus.subscribe('spinner:GameConfigEvent', buyBonusPopup.onGameConfig);
  messageBus.subscribe('common:BalanceEvent', buyBonusPopup.onBalanceEvent);
  messageBus.subscribe('game:modal', buyBonusPopup.onModal);

  buyBonusPopup.helpActive = false;
};

buyBonusPopup.onModal = function (data) {
  if (buyBonusPopup.container.visible) {
    if (data.reason && data.reason === 'Options menu open') {
      buyBonusPopup.helpActive = true;

      buyBonusPopup.freeSpinsButton.enableButton(false);
      buyBonusPopup.closeButton.enableButton(false);

      // update the stake buttons
      buyBonusPopup.stakePreviousButton.enableButton(false);
      buyBonusPopup.stakeNextButton.enableButton(false);
    } else if (buyBonusPopup.helpActive) {
      buyBonusPopup.helpActive = false;

      buyBonusPopup.freeSpinsButton.enableButton(true);
      buyBonusPopup.closeButton.enableButton(true);

      buyBonusPopup.updatePopup();
    }

    if (buyBonusPopup.open) {
      if (data.reason === undefined) {
        messageBus.post('game:modal', { reason: 'buy_bonus', data: 'buy_bonus_show (onModal)' });
      }
    }
  }
};

buyBonusPopup.onGameConfig = function (event) {
  buyBonusPopup.gameConfig = event;
  buyBonusPopup.init();
};

buyBonusPopup.onBalanceEvent = function (event) {
  buyBonusPopup.balance = event.data.balance;
};

buyBonusPopup.onClosePopup = function (buyBonus) {
  soundManager.play('buttonPressed');

  buyBonusPopup.open = false;

  if (buyBonus) {
    buyBonusPopup.onStartBonusSpin();
  } else {
    // Not buying a bonus, so reset
  }

  let reels = resourceManager.get('slotContainer:reelContainer');
  reels.alpha = 1.0;

  buyBonusPopup.container.visible = false;
  buyBonusPopup.callback(buyBonus);
};

buyBonusPopup.onStartBonusSpin = function () {
  gameData.winningsMeter.set(0);
  gameController.inBuyABonus = true;

  // Remove modal
  messageBus.post('game:modal', { data: 'buy_bonus_start' });

  let stakeController = resourceManager.getController('stakeController');
  const numLines = stakeController.CurrentWinLineCount;

  const bonusBuyStakes = buyBonusPopup.freeSpinsStakes;

  // we should be ok to use the combined stake index as the button will be disabled if not an allowable stake
  let baseStake = buyBonusPopup.convertToTotalStake(bonusBuyStakes[buyBonusPopup.stakeIndex]);

  let stakes = stakeController.Stakes;
  let returnStake = stakes.find((stake) => stake === baseStake);

  if (!returnStake) {
    returnStake = stakes[0];
  }

  stakeController.requestChangeStake(returnStake);
  stakeController.requestChangeStake(baseStake, 'FREESPINS_BUY');

  const bpl = baseStake / numLines;
  const buyCost = buyBonusPopup.gameConfig.data.buyBonusCostFreeSpins;

  gameController.initNewSpin();

  gdk.startGame(
    {
      stake: baseStake * buyCost,
      numWinlines: numLines,
      bpl: bpl,
      metaData: {
        encore: false,
        buyABonus: true,
      },
    },
    function () {
      gdk.getNextGameOutcome(function () {});
    }
  );
};

buyBonusPopup.onClickedYes = function () {
  buyBonusPopup.onClosePopup(true);
};

buyBonusPopup.onClickedFreeSpins = function () {
  buyBonusPopup.onClosePopup(true);
};

buyBonusPopup.onClickedNo = function () {
  buyBonusPopup.open = false;

  messageBus.post('game:modal', { data: 'buy_bonus_cancel' });

  buyBonusPopup.onClosePopup(false);
};

buyBonusPopup.onInfo = function () {
  soundManager.play('buttonPressed');
  gameData.helpPageScroll.open();
};

buyBonusPopup.getFilesRequired = function (json) {
  return [];
};

resourceManager.registerObjectType(
  'buyBonusPopup',
  buyBonusPopup.create,
  buyBonusPopup.initialise,
  buyBonusPopup.getFilesRequired
);
